module.exports = __webpack_public_path__ + "static/media/bg.2d11d80.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.mp3
// module id = r0He
// module chunks = 0